var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
    },
    [
      _c(
        "el-select",
        {
          staticStyle: { width: "100%" },
          attrs: {
            disabled: _vm.disabled,
            "allow-create": _vm.isTextInput || _vm.allowCreate,
            clearable: "",
            "no-data-text": "Enter request state/province",
            filterable: "",
            placeholder: _vm.placeholder,
            name: "state",
          },
          model: {
            value: _vm.stateCode,
            callback: function ($$v) {
              _vm.stateCode = $$v
            },
            expression: "stateCode",
          },
        },
        [
          _vm._l(_vm.states, function (state, _code) {
            return _vm.isDomestic
              ? _c(
                  "el-option",
                  { key: _code, attrs: { value: _code, label: state.name } },
                  [
                    _c("span", { staticStyle: { float: "left" } }, [
                      _vm._v(_vm._s(state.name)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticStyle: { float: "right", color: "#999" } },
                      [_vm._v(_vm._s(_vm._f("uppercase")(_code)))]
                    ),
                  ]
                )
              : _vm._e()
          }),
          _vm._v(" "),
          _vm._l(_vm.states, function (state, _code) {
            return !_vm.isDomestic
              ? _c(
                  "el-option",
                  {
                    key: state.name,
                    attrs: { value: state.name, label: state.name },
                  },
                  [
                    _c("span", { staticStyle: { float: "left" } }, [
                      _vm._v(_vm._s(state.name)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticStyle: { float: "right", color: "#999" } },
                      [_vm._v(_vm._s(_vm._f("uppercase")(state.code)))]
                    ),
                  ]
                )
              : _vm._e()
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }